<template>
  <div class="top-div">
    <img v-if="!isHome" class="home-img" src="../assets/img/home.png" @click="pathTo('home')">
    <div class="option-box">
      <div class="list" @click="openCloseAudio">
        <i class="el-icon-message-solid"></i>
        <div>{{ openAudio ? '关闭语音提醒' : '开启语音提醒' }}</div>
      </div>
      <div class="list">
        <img src="../assets/img/user-icon.png">
        <div>{{ userInfo.username ? userInfo.username : '未登录' }}</div>
      </div>
      <div class="list" @click="loginOut">
        <img src="../assets/img/loginOut.png">
        <div>{{ userInfo.username ? '退出登录' : '去登录' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "top",
  props: {
    openAudio: { type: Boolean,default: false }
  },
  mounted() {
    this.isHome = this.$route.name === 'home'
    this.userInfo = this.$store.state.user.userInfo
  },
  watch: {
    $route () {
      this.isHome = this.$route.name === 'home'
    }
  },
  data () {
    return{
      userInfo: {},
      isHome: false,
    }
  },
  methods:{
    loginOut () {
      this.$router.push({ name: 'login' })
    },
    pathTo (name) {
      this.$router.push({ name: name })
    },
    openCloseAudio () {
      this.$emit('openCloseAudio')
    }
  }
}
</script>

<style scoped lang="less">
  .top-div{
    width: 100vw;
    height: 95px;
    background-image: url("../assets/img/top-bg.png");
    background-size: 100% 100%;
    position: relative;
    .home-img{
      position: absolute;
      width: 114px;
      height: 98px;
      cursor: pointer;
    }
    .option-box{
      display: flex;
      position: absolute;
      right: 30px;
      height: 95px;
      align-items: center;
      .list{
        display: flex;
        min-width: 90px;
        cursor: pointer;
        i{
          font-size: 20px;
          margin-top: 5px;
          margin-right: 2px;
          text-shadow: 3px 2px 5px #32b0f8;
        }
        img{
          width: 32px;
          height: 32px;
        }
        div{
          font-size: 14px;
          line-height: 30px;
          text-shadow: 3px 2px 5px #32b0f8;
        }
      }
    }
  }
</style>
